"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MODES = void 0;
var MODES = exports.MODES = {
  PARENT: 'parent',
  POPOUT: 'popout'
};